import { IEvent } from 'fabric/fabric-impl';

export interface IResultInfo {
  events: IEventResult[];
}

export interface IEventResult {
  id: number;
  fairName: string;
  awardDate: string;
}

export interface IEventResultsInfo {
  categories: string[];
  schools: string[];
  participants: IEventParticipant[];
}

export interface IEventParticipant {
  title: string;
  category: string;
  school: string;
  firstName: string;
  lastName: string;
  award: string;
  points: number;
  projectId: number;
  specialAwards: IEventSpecialAward[];
}

export interface IEventSpecialAward {
  award: string;
  subType: string;
  points: number;
}

export interface IArchiveSearchInfo {
  events: IEventResult[];
  columns: string[];
}

export interface IArchiveSearchResult {
  data: IArchiveResult[];
}

export interface IArchiveResult {
  DataSetId: number;
  DataSetYear: number;
  Id: number;
  LastName: string;
  FirstName: string;
  Phone: string;
  CellPhone: string;
  Email: string;
  ParentEmail: string;
  PersonTagsCsv: string;
  City: string;
  State: string;
  Zip: string;
  Street1: string;
  Street2: string;
  Grade: number;
  Gender: string;
  Project_id_int: number;
  IsTeam: boolean;
  TeamMembers: string;
  Title: string;
  Category_name: string;
  ProjectId: string;
  ProjectTagsCsv: string;
  ProjectDescription: string;
  EntryTypeName: string;
  School: string;
  TeacherFirstName: string;
  TeacherLastName: string;
  ProjectStatus: string;
  Award: string;
  ProjectPlan: string;
  ProjectAbstract: string;
  SpecialAward: string;
  SpecialAwardSubType: string;
  SpecialAwards: string[];
}

export interface IArchiveResultsSearchRequest {
  search?: IArchiveResultsSearchTerm[];
  operator?: ArchiveResultsSearchOperator;
  events?: number[];
  grades?: number[];
  firstName?: string;
  lastName?: string;
  projectTitle?: string;
  school?: string;
  category?: string;
  award?: string;
  specialAward?: string;
  projectId?: string;
  teacherFirstName?: string;
  teacherLastName?: string;
  
  firstNameOperator?: ArchiveResultsSearchOperator;
  lastNameOperator?: ArchiveResultsSearchOperator;
  projectTitleOperator?: ArchiveResultsSearchOperator;
  schoolOperator?: ArchiveResultsSearchOperator;
  categoryOperator?: ArchiveResultsSearchOperator;
  awardOperator?: ArchiveResultsSearchOperator;
  specialAwardOperator?: ArchiveResultsSearchOperator;
  projectIdOperator?: ArchiveResultsSearchOperator;
  teacherFirstNameOperator?: ArchiveResultsSearchOperator;
  teacherLastNameOperator?: ArchiveResultsSearchOperator;

  orderBy?: string[];
}

export interface IArchiveResultsSearchTerm {
  value: string;
  column: string;
  operator: ArchiveResultsSearchOperator;
}

export enum ArchiveResultsSearchOperator {
  And = 'And',
  Or = 'Or',
  Equal = 'Equal',
  NotEqual = 'NotEqual',
  LessThan = 'LessThan',
  LessThanOrEqual = 'LessThanOrEqual',
  GreaterThanOrEqual = 'GreaterThanOrEqual',
  GreaterThan = 'GreaterThan',
  StartsWith = 'StartsWith',
  EndsWith = 'EndsWith',
  Contains = 'Contains',
}
